import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Spin } from "antd";
import { ArrowLeft2 } from "iconsax-react";

import PageHeader from "../../components/PageHeader";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import { useContent, SuggestionItem } from "../../hooks/content";
import useAdminGuard from "../../hooks/useAdminGuard";

import { Container, Main, DetailCard, MetaRow, Label } from "./styles";

const SuggestionDetail: React.FC = () => {
  useAdminGuard();
  const { uid } = useParams<{ uid: string }>();
  const navigate = useNavigate();
  const { getSuggestion } = useContent();
  const [item, setItem] = useState<SuggestionItem | null | undefined>(
    undefined
  );

  const load = useCallback(async () => {
    if (!uid) {
      setItem(null);
      return;
    }
    try {
      const data = await getSuggestion(uid);
      setItem(data);
    } catch {
      setItem(null);
    }
  }, [getSuggestion, uid]);

  useEffect(() => {
    load();
  }, [load]);

  if (item === undefined) {
    const loadingHeader = {
      title: "Sugestão",
      description: "Carregando…",
      type: "private" as const,
    };
    return (
      <Container id="page">
        <PageHeader {...loadingHeader} />
        <Main>
          <Spin />
        </Main>
        <Footer />
      </Container>
    );
  }

  if (!item) {
    return (
      <Container id="page">
        <PageHeader
          title="Sugestão não encontrada"
          description="O registro não existe em suggestions/{uid} no Firebase."
          type="private"
        />
        <Main>
          <Button type="primary" onClick={() => navigate("/suggestions")}>
            Voltar à lista
          </Button>
        </Main>
        <Footer />
      </Container>
    );
  }

  return (
    <Container id="page">
      <PageHeader
        title={item.title || "Sugestão"}
        description="Dados conforme o nó suggestions no Realtime Database"
        type="private"
      />
      <Main>
        <Breadcrumb
          items={[
            { label: "Gerenciamento", link: "/manager" },
            { label: "Sugestões", link: "/suggestions" },
            { label: item.title || item.uid, active: true },
          ]}
        />
        <Button
          type="text"
          icon={<ArrowLeft2 size={18} />}
          onClick={() => navigate("/suggestions")}
          style={{ marginBottom: 16, paddingLeft: 0 }}
        >
          Voltar
        </Button>

        <DetailCard>
          <MetaRow>
            <Label>uid (chave Firebase)</Label>
            <code>{item.uid}</code>
          </MetaRow>
          <MetaRow>
            <Label>Título</Label>
            <span>{item.title}</span>
          </MetaRow>
          <MetaRow>
            <Label>Descrição</Label>
            <p style={{ margin: 0, whiteSpace: "pre-wrap" }}>
              {item.description}
            </p>
          </MetaRow>
          <MetaRow>
            <Label>fromUser</Label>
            <span>{item.fromUser ?? "—"}</span>
          </MetaRow>
          <MetaRow>
            <Label>createdAt (ISO)</Label>
            <span>{item.createdAt}</span>
          </MetaRow>
        </DetailCard>
      </Main>
      <Footer />
    </Container>
  );
};

export default SuggestionDetail;
